import { PureComponent } from 'react';
import { Field as RfField } from 'redux-form';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import cn from 'classnames';
import Control from '../Control';

export default class Field extends PureComponent {
  hasError({ meta: { error, touched } }) {
    return touched && error;
  }

  renderHelpBlock = ({ meta, meta: { error } }) => {
    return this.hasError({ meta }) ? <HelpBlock>{error}</HelpBlock> : null;
  };

  renderComponent = (props) => {
    return (
      <span className={cn({ 'has-error': this.hasError(props) })}>
        <Control {...props} />
        {this.renderHelpBlock(props)}
      </span>
    );
  };

  render() {
    return <RfField {...this.props} component={this.renderComponent} />;
  }
}
